import React from "react";

import CameraView from "components/camera/CameraView";

export default function Camera() {
  return <CameraView />;
}
